import ApplicationsRepository from './applicationsRepository'
import ZipcodeRepository from './zipcodesRepository'

const repositories = {
  applications: ApplicationsRepository,
  zipcodes: ZipcodeRepository,
}

export default {
  get: name => repositories[name]
}



// WEBPACK FOOTER //
// ./src/repositories/api.js